export interface IApp {
  id?: number;
  app_secret?: string;
  packageName?: string;
  tenantId?: number;
}

export const defaultValue: Readonly<IApp> = {};
